import { connect } from 'react-redux'
import {reduxForm, formValueSelector} from 'redux-form'
import {requestFeedbackReply, sendFeedbackReplyForm} from 'actions/feedbackReplyForm'
import './index.css'
import moment from 'moment'
import MessageForm from './messageForm.js'

class FeedbackReplyForm extends React.Component {
  componentDidMount () {
    let token = this.props.params.token
    this.props.dispatch(requestFeedbackReply(token))
  }
  render () {
    let {data, isInvalidToken} = this.props.data
    let feedbackList = data
    return (
      <section className='base-content-reply-feedback'>
        <div className='container'>
          <div className='col-md-12 col-xs-12'>
            {isInvalidToken
            ? 'invalid'
            : <div className='maincontent-feedback-reply-detail col-md-7 col-xs-12'>
              <div className='title-content'>
                <img className='img-circle' width='140px' height='140px' src={feedbackList && feedbackList.business_logo_url} />
                <div className='store-name'>{feedbackList && feedbackList.business_name}</div>
              </div>
              <hr />
              <div className='reply-content'>
                {feedbackList
                ? feedbackList.messages.map((message) => {
                  return (
                    <div>
                      { message.is_customer
                        ? <div className='user'>
                          <div className='customer-message'>
                            <div className='left-content have-avatar pull-left'>
                              <div>
                                <img alt='Account profile default' className='avatar' src='https://dev.mokapos.com/assets/account-profile-default.jpg' />
                              </div>
                              <span>{data.customer_name !== '-' ? data.customer_name : data.customer_email}</span>
                            </div>
                            <div className='right-content have-box pull-right'>
                              <div className='title'>
                                  ({message.feedback_type}) - {moment(message.created_at).format('DD MMM YYYY HH:mm')}
                                <span className='icon-thumb'>
                                  <img alt='Smile icon thumb' src={message.mode === 'happy' ? 'https://dev.mokapos.com/assets/smile-icon-thumb.png' : 'https://dev.mokapos.com/assets/sad-icon-thumb.png'} />
                                </span>
                              </div>
                              <div className='content'>
                                {message.comment}
                              </div>
                            </div>
                          </div>
                        </div>
                        : <div className='business'>
                          <div className='admin-message'>
                            <div className='left-content have-box pull-left'>
                              <div className='title ng-binding'>
                                {moment(message.created_at).format('DD MMM YYYY HH:mm')}
                              </div>
                              <div className='admin-message-wrapper ng-binding'>
                                {message.comment}
                              </div>
                            </div>
                            <div className='right-content have-avatar pull-right'>
                              <div className='image-thumb-box ng-scope'>
                                <img className='avatar-business' src={message.profile_pict_url || 'https://mokapos-production.s3.amazonaws.com/uploads/business/logo/2451/1450670597-clash-of-clans-gold-bedcd386.png'} />
                              </div>
                            </div>
                          </div>
                        </div>}
                    </div>
                  )
                })
                : ''
              }
              </div>
              <div className='customer-reply-form'>
                <MessageForm
                  onSubmit={this.handleSubmit}
                  data={data}
                />
              </div>
            </div>
            }

          </div>
        </div>
      </section>
    )
  }

  handleSubmit = (values) => {
    let {comment} = values
    let token = this.props.params.token
    this.props.dispatch(sendFeedbackReplyForm(comment, token))
  }
}

formValueSelector('feedbackReplyForm') // <-- same as form name

function mapStateToProps (state) {
  return {
    data: state.feedback.replyForm,
    form: state.form.feedbackReplyForm,
    moka: state.moka
  }
}

const mapFormValidation = {
  form: 'feedbackReplyForm'
}

export default reduxForm(mapFormValidation)(connect(mapStateToProps)(FeedbackReplyForm))



// WEBPACK FOOTER //
// ./app/pages/FeedbackReplyForm/index.js